export const oldMore = {
  en: {
    stats: [
      ["4", "Cents of land donated"],
      ["900", "Sq ft concrete house donated"],
      ["2", "Panchayats we serve: Mundur & Kongad"],
    ],
    forTitle: "Who the home is for",
    forText: "Some elders have no one to look after them. We intend to set up an old age home at a suitable location to care for them, for the elders of Mundur, Kongad and the surrounding areas.",
    forPoints: [
      "Elders who have no one to look after them",
      "Mundur, Kongad and the surrounding areas"
    ],
    giftTitle: "A first step: land and a house",
    giftText: "Smt. Saraswathi Amma of Puthuppariyaram has donated four cents of land and a 900 sq ft concrete house for the trust's future activities, after her lifetime.",
    giftNote: "The gift takes effect after her lifetime.",
    roadTitle: "Our plan",
    road: [
      ["The gift", "Four cents of land and a 900 sq ft concrete house, donated for the trust's future activities."],
      ["The home", "Set up an old age home at a suitable location to care for elders who have no one."],
      ["How it is funded", "Public donations and the trust's own funds."],
    ],
    helpTitle: "How you can help",
    help: [
      ["Donate", "Every contribution brings the old age home closer. Bank details are on the Contact page.", "Support this plan"],
      ["Call us", "Want to support in another way, or have a question? Speak to us directly.", "Call the trust"],
    ],
  },
  ml: {
    stats: [
      ["4", "സെന്റ് ഭൂമി സംഭാവന"],
      ["900", "ചതുരശ്ര അടി കോൺക്രീറ്റ് വീട് സംഭാവന"],
      ["2", "ഞങ്ങൾ സേവിക്കുന്ന പഞ്ചായത്തുകൾ: മുണ്ടൂർ, കോങ്ങാട്"],
    ],
    forTitle: "ആർക്കുവേണ്ടിയാണ് ഈ സദനം",
    forText: "സംരക്ഷിക്കാൻ ആരുമില്ലാത്ത വയോജനങ്ങളുണ്ട്. മുണ്ടൂർ, കോങ്ങാട്, പരിസര പ്രദേശങ്ങളിലെ അവരെ പരിചരിക്കാൻ അനുയോജ്യമായ സ്ഥലത്ത് വൃദ്ധസദനം സ്ഥാപിക്കാൻ ഞങ്ങൾ ഉദ്ദേശിക്കുന്നു.",
    forPoints: [
      "സംരക്ഷിക്കാൻ ആരുമില്ലാത്ത വയോജനങ്ങൾ",
      "മുണ്ടൂർ, കോങ്ങാട്, പരിസര പ്രദേശങ്ങൾ",
    ],
    giftTitle: "ആദ്യ ചുവട്: ഭൂമിയും വീടും",
    giftText: "പുതുപ്പരിയാരത്തെ ശ്രീമതി സരസ്വതി അമ്മ, ട്രസ്റ്റിന്റെ ഭാവി പ്രവർത്തനങ്ങൾക്കായി തന്റെ കാലശേഷം നാല് സെന്റ് ഭൂമിയും 900 ചതുരശ്ര അടി കോൺക്രീറ്റ് വീടും നൽകുമെന്ന് അറിയിച്ചു.",
    giftNote: "ഈ സംഭാവന അവരുടെ കാലശേഷമാണ് പ്രാബല്യത്തിൽ വരുന്നത്.",
    roadTitle: "ഞങ്ങളുടെ പദ്ധതി",
    road: [
      ["സംഭാവന", "ട്രസ്റ്റിന്റെ ഭാവി പ്രവർത്തനങ്ങൾക്കായി നാല് സെന്റ് ഭൂമിയും 900 ചതുരശ്ര അടി കോൺക്രീറ്റ് വീടും."],
      ["സദനം", "നോക്കാൻ ആരുമില്ലാത്ത വയോജനങ്ങളെ പരിചരിക്കാൻ അനുയോജ്യമായ സ്ഥലത്ത് വൃദ്ധസദനം സ്ഥാപിക്കുക."],
      ["ഫണ്ട് എങ്ങനെ", "പൊതുസംഭാവനകളും ട്രസ്റ്റിന്റെ സ്വന്തം ഫണ്ടും."],
    ],
    helpTitle: "നിങ്ങൾക്ക് എങ്ങനെ സഹായിക്കാം",
    help: [
      ["സംഭാവന നൽകൂ", "ഓരോ സംഭാവനയും വൃദ്ധസദനത്തെ അടുപ്പിക്കുന്നു. ബാങ്ക് വിവരങ്ങൾ ബന്ധപ്പെടുക പേജിലുണ്ട്.", "ഈ പദ്ധതിയെ പിന്തുണയ്ക്കൂ"],
      ["ഞങ്ങളെ വിളിക്കൂ", "മറ്റ് വിധത്തിൽ പിന്തുണയ്ക്കണോ, അല്ലെങ്കിൽ എന്തെങ്കിലും ചോദിക്കാനുണ്ടോ? നേരിട്ട് സംസാരിക്കൂ.", "ട്രസ്റ്റിനെ വിളിക്കൂ"],
    ],
  },
};